import request from "@/utils/request";

export function GetBranchMenus(branchId, startDate, endDate) {
  return request({
    url: "/Menu/GetBranchMenus",
    method: "post",
    data: {
      BranchId: branchId,
      Startdate: startDate,
      EndDate: endDate,
    },
  });
}

export function GetMealMenus(mealId, tarikh, placeid) {
  return request({
    url: "/Menu/GetMealMenus",
    method: "post",
    data: {
      MealId: mealId,
      Tarikh: tarikh,
      DeliveryPlaceId: placeid,
    },
  });
}

export function SaveMenu(
  id,
  branchId,
  foodId,
  mealId,
  tarikh,
  sort,
  foodCapacity,
  menuPrices
) {
  return request({
    url: "/Menu/Save",
    method: "post",
    data: {
      Id: id,
      BranchId: parseInt(branchId),
      FoodId: parseInt(foodId),
      MealId: parseInt(mealId),
      Tarikh: tarikh,
      Sort: sort,
      FoodCapacity: foodCapacity,
      MenuPrices: menuPrices,
    },
  });
}

export function DeleteMenu(id) {
  return request({
    url: "/Menu/Delete",
    method: "post",
    data: {
      Id: id,
    },
  });
}

export function DeleteDays(days, branchId) {
  return request({
    url: "/Menu/DeleteDays",
    method: "post",
    data: {
      BranchId: branchId,
      Days: days,
    },
  });
}

export function CopyMenu(branchId, startdate, endDate, destinationDate) {
  return request({
    url: "/Menu/CopyMenu",
    method: "post",
    data: {
      BranchId: branchId,
      Startdate: startdate,
      Destinationdate: destinationDate,
      EndDate: endDate,
    },
  });
}

export function CancelMenu(menuId, deliveryPlaceID) {
  return request({
    url: "/Menu/CancelMenu",
    method: "post",
    data: {
      MenuID: menuId,
      DeliveryPlaceID: deliveryPlaceID,
    },
  });
}
